/**
 * Informations légales de l'éditeur du Dashboard Adweb-Systèmes.
 *
 * Adweb-Systèmes est une marque commerciale de la société ADWEB CONSEIL : l'identité
 * juridique (raison sociale, SIRET, RCS…) reste celle d'ADWEB CONSEIL.
 *
 * Les champs marqués `[À COMPLÉTER]` doivent être remplis avant la mise en
 * production / commercialisation. Une fois renseignés, ils alimentent
 * automatiquement les pages publiques (mentions légales, CGV, etc.).
 *
 * Mise à jour : adapter `LAST_UPDATED` à chaque modification substantielle
 * des documents légaux (CGV, politique de confidentialité, etc.).
 */
export const LEGAL_INFO = {
  // Identité commerciale
  companyName: 'ADWEB CONSEIL',
  brandName: 'Adweb-Systèmes',
  brandWebsiteUrl: 'https://adweb-systemes.fr',
  productName: 'Dashboard Adweb-Systèmes',
  productDescription: 'plateforme de pilotage des automatisations IA n8n',
  websiteUrl: 'https://adweb-conseil.fr',
  dashboardUrl: 'https://dashboard.adweb-systemes.cloud',

  // Identité juridique
  legalForm: 'SARL (société à responsabilité limitée)',
  capital: '2 000,00 €',
  siret: '80103069300049',
  rcs: 'Poitiers — 801 030 693 R.C.S. Poitiers',
  vatNumber: 'FR26801030693',
  legalAddress: '29 rue de Guerstling, 86450 Chenevelles, France',
  legalRepresentative: 'Mickaël Pelletier (gérant)',

  // Contacts
  contactEmail: 'contact@adweb-conseil.fr',
  dpoEmail: 'contact@adweb-conseil.fr', // Pas de DPO formel obligatoire pour une PME, le contact RGPD passe par cet e-mail
  dpoName: 'Mickaël Pelletier (référent RGPD)',
  phone: '05 49 21 10 48',

  // Hébergement
  hostingProvider: 'Hostinger International Ltd.',
  hostingAddress: '61 Lordou Vironos Street, 6023 Larnaca, Chypre',
  hostingWebsite: 'https://www.hostinger.fr',

  // Documents — versions et dates
  lastUpdated: '2026-10-26',
  version: '1.1',

  // Tribunal compétent
  jurisdiction: 'Tribunal de commerce de Poitiers',
} as const;
